module.exports = __webpack_public_path__ + "img/st-6.b0a6e058.png";